import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect, useCallback } from 'react';
const ThemeContext = createContext(undefined);
export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => {
        try {
            const saved = localStorage.getItem('icavi-theme');
            if (saved === 'dark' || saved === 'light')
                return saved;
            // Sempre iniciar em modo claro, ignorando preferência do sistema
        }
        catch {
            // fallback se localStorage não disponível
        }
        return 'light';
    });
    useEffect(() => {
        const root = document.documentElement;
        if (theme === 'dark') {
            root.classList.add('dark');
        }
        else {
            root.classList.remove('dark');
        }
        root.style.colorScheme = theme;
        const themeMeta = document.querySelector('meta[name="theme-color"]');
        if (themeMeta) {
            themeMeta.setAttribute('content', theme === 'dark' ? '#0f0f0f' : '#fafafa');
        }
        try {
            localStorage.setItem('icavi-theme', theme);
        }
        catch {
            // fallback se localStorage não disponível
        }
    }, [theme]);
    const toggleTheme = useCallback(() => {
        setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
    }, []);
    return (_jsx(ThemeContext.Provider, { value: { theme, toggleTheme, isDark: theme === 'dark' }, children: children }));
}
export function useTheme() {
    const context = useContext(ThemeContext);
    if (!context)
        throw new Error('useTheme deve ser usado dentro de ThemeProvider');
    return context;
}
